import React from "react";
import PropTypes from "prop-types";
import Region from "../../../../models/Region";

function ZoomToRegion({ jumpTo, region, requestClose }) {
  return region ? (
    <div
      data-tooltip="Zoom to region of this item"
      data-tooltip-class="genome-browser-small-tooltip"
      onClick={() => {
        jumpTo(region.g0, region.g1);
        requestClose();
      }}
    >
      <div className="hover:tw-text-blueGray-900 tw-text-blueGray-700 tw-cursor-pointer">
        <i className="fa fa-search-plus" />
      </div>
    </div>
  ) : null;
}

ZoomToRegion.propTypes = {
  region: PropTypes.instanceOf(Region),
  jumpTo: PropTypes.func.isRequired,
  requestClose: PropTypes.func.isRequired,
};

ZoomToRegion.defaultProps = {
  region: null,
};

ZoomToRegion.propTypes = {};

export default ZoomToRegion;
